import { Box, Button } from "@mui/material";

const AmountButton = ({ value, selected, onClick }) => (
  <Button
    onClick={() => onClick(value)}
    sx={{
      borderRadius: 20,
      border: "1px solid #FF8A00",
      fontStyle: "italic",
      color: "white",
      backgroundColor: selected ? "#FF8A00" : "transparent",
      "&:hover": {
        backgroundColor: selected ? "#FF8A00" : "rgba(255, 138, 0, 0.1)",
      },
      padding: "4px 20px",
      minWidth: "auto",
    }}
  >
    {value}
  </Button>
);

export default function AmountButtons({
  amounts,
  selectedAmount,
  onAmountClick,
}) {
  return (
    <Box sx={{ display: "flex", gap: 1.4, flexWrap: "wrap" }}>
      {amounts.map((value) => (
        <AmountButton
          key={value}
          value={value}
          selected={selectedAmount === value}
          onClick={onAmountClick}
        />
      ))}
    </Box>
  );
}
